// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__6oOtA","resendInfoText":"OnGoingPaymentBox_resendInfoText__1Xnq0"};